import { render, staticRenderFns } from "./BlockActivity.vue?vue&type=template&id=9d94e47c"
import script from "./BlockActivity.vue?vue&type=script&lang=js"
export * from "./BlockActivity.vue?vue&type=script&lang=js"
import style0 from "./BlockActivity.vue?vue&type=style&index=0&id=9d94e47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports